import { ISection } from '@/typings';

import { adaptDecimalValueToPercentage } from '../utilities';
import { ApplicationSectionResponseDTO } from '@/api/application/DTOs';

export const adaptApplicationSectionResponseToSection = (
  applicationSectionResponse: ApplicationSectionResponseDTO[],
): ISection[] => {
  return applicationSectionResponse.map(section => {
    const fieldsSummary = section.fieldsSummary;

    return {
      id: section.applicationFormSectionID,
      title: section.title,
      image: section.image,
      requiredFieldsCount: fieldsSummary?.requiredFieldsCount ?? 0,
      fieldsCount: fieldsSummary?.fieldsCount ?? 0,
      pendingRequiredFieldsCount:
        fieldsSummary?.pendingRequiredFieldsCount ?? 0,
      pendingFieldsCount: fieldsSummary?.pendingFieldsCount ?? 0,
      restrictionViolationsCount:
        fieldsSummary?.restrictionViolationsCount ?? 0,
      completedPercentage: adaptDecimalValueToPercentage(
        fieldsSummary?.completedPercentage ?? 0,
      ),
      requiredDocuments: section.requiredDocuments,
      validationMessages: section.validationMessages,
      estimatedWorkRemainingInMinutes: section.estimatedWorkRemainingInMinutes,
    };
  });
};
